<template>
  <!-- x.com-style persistent tab bar — phones/tablets only (lg keeps the top
       nav + drawer). Primary destinations are one tap away; the Menu tab
       opens the existing mobile drawer for everything else. -->
  <nav
    class="lg:hidden fixed bottom-0 left-0 right-0 z-50 border-t bg-white border-(--nviya-border) dark:bg-surface dark:border-primary/30 pb-[env(safe-area-inset-bottom)]"
    aria-label="Primary"
  >
    <div class="flex items-stretch h-14">
      <NuxtLink
        v-for="tab in tabs"
        :key="tab.id"
        :to="tab.route"
        class="flex-1 flex flex-col items-center justify-center gap-1 transition-colors"
        :class="isActive(tab)
        ? 'text-primary dark:text-white'
        : 'text-slate-400 hover:text-slate-600 dark:text-white/60 dark:hover:text-white/80'"
      >
        <FontAwesome :icon="['fas', tab.icon]" class="w-5 h-5" />
        <span class="text-[10px] font-medium leading-none">{{ tab.label }}</span>
      </NuxtLink>
      <button
        class="flex-1 flex flex-col items-center justify-center gap-1 transition-colors text-slate-400 hover:text-slate-600 dark:text-white/60 dark:hover:text-white/80"
        @click="$emit('open-menu')"
      >
        <FontAwesome :icon="['fas', 'bars']" class="w-5 h-5" />
        <span class="text-[10px] font-medium leading-none">Menu</span>
      </button>
    </div>
  </nav>
</template>

<script setup>
defineEmits(['open-menu'])

const route = useRoute()

const tabs = [
  { id: 'home', label: 'Home', icon: 'home', route: '/home' },
  { id: 'companies', label: 'Companies', icon: 'building', route: '/companies' },
  { id: 'alerts', label: 'Alerts', icon: 'bell', route: '/alerts' },
  { id: 'chat', label: 'Chat', icon: 'comments', route: '/chat' },
]

const isActive = (tab) => {
  const p = (route.path || '/').replace(/\/+$/, '') || '/'
  if (tab.id === 'home') return p === '/' || p === '/home' || p === '/dashboard'
  if (tab.id === 'companies') {
    return p.startsWith('/companies') || p.startsWith('/company-intelligence')
  }
  return p === tab.route || p.startsWith(tab.route + '/')
}
</script>
